import { render } from "./AssetDetailView.vue?vue&type=template&id=2ba2ae8a&scoped=true"
import script from "./AssetDetailView.vue?vue&type=script&lang=js"
export * from "./AssetDetailView.vue?vue&type=script&lang=js"

import "./AssetDetailView.vue?vue&type=style&index=0&id=2ba2ae8a&scoped=true&lang=css"

import exportComponent from "D:\\Github\\cj-assets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba2ae8a"]])

export default __exports__